import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4985fb5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Play")
const _hoisted_2 = { class: "details-box ranking shadow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "O", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-ellipsis" }, "Coins", -1))
const _hoisted_5 = { class: "text-ellipsis" }
const _hoisted_6 = { class: "details-box earned shadow" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Match", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading ion-padding" }, "I TUOI PROSSIMI MATCH", -1))
const _hoisted_10 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Termina tra ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading ion-padding" }, "MATCH ESEGUITI", -1))
const _hoisted_15 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("contro ")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Guadagnati ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "bg-light ion-padding",
        "padding-left": "",
        "padding-right": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => ($setup.doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "banner" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _hoisted_4,
                    _createElementVNode("h3", _hoisted_5, _toDisplayString($setup.userTotalcoins), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h2", null, [
                      _createElementVNode("img", {
                        src: require('@/assets/imgs/white_icon.png')
                      }, null, 8, _hoisted_7)
                    ]),
                    _hoisted_8,
                    _createElementVNode("h3", null, _toDisplayString($setup.userTotalmatches), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "shadow categories" }, {
            default: _withCtx(() => [
              _hoisted_9,
              (!$setup.hasUpcomingMatches)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Nessun match disponibile al momento."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upcomingMatches, (match) => {
                return (_openBlock(), _createBlock(_component_ion_row, {
                  key: match.id,
                  onClick: ($event: any) => ($setup.openQuiz(match)),
                  size: "12",
                  "col-12": "",
                  "text-center": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, {
                          style: _normalizeStyle([{"border":"solid 2px","border-radius":"5px"}, 'border-color: '+$setup.matchResultResolver(match.my_match_result).color]),
                          lines: "none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  src: $setup.calendarOutline,
                                  size: "large"
                                }, null, 8, ["src"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(match.start_times), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            (match.status === 'doing')
                              ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_avatar, {
                                      class: "fit-avatar",
                                      slot: "start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: $setup.resolveChallengerAvatar(match.challenger).avatar,
                                          alt: $setup.resolveChallengerAvatar(match.challenger).alt
                                        }, null, 8, _hoisted_11)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        (match.challenger)
                                          ? (_openBlock(), _createElementBlock("strong", {
                                              key: 0,
                                              style: _normalizeStyle(`color: ${match.challenger.color}`)
                                            }, _toDisplayString(match.challenger.fullName), 5))
                                          : (_openBlock(), _createElementBlock("strong", _hoisted_12, "SWItaly"))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (match.remaining_time)
                              ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, [
                                      _hoisted_13,
                                      _createElementVNode("strong", null, _toDisplayString(match.remaining_time) + "m", 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["style"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "shadow categories" }, {
            default: _withCtx(() => [
              _hoisted_14,
              (!$setup.hasExecutedMatches)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Nessun match eseguito."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.executedMatches, (match) => {
                return (_openBlock(), _createBlock(_component_ion_row, {
                  key: match.id,
                  size: "12",
                  "col-12": "",
                  "text-center": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, {
                          style: _normalizeStyle([{"border":"solid 2px","border-radius":"5px"}, 'border-color: '+$setup.matchResultResolver(match.my_match_result, match.status).color]),
                          lines: "none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  src: $setup.calendarOutline,
                                  size: "large"
                                }, null, 8, ["src"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(match.start_times), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  src: $setup.matchResultResolver(match.my_match_result, match.status).icon,
                                  size: "large"
                                }, null, 8, ["src"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("strong", {
                                      style: _normalizeStyle('color: '+$setup.matchResultResolver(match.my_match_result, match.status).color)
                                    }, _toDisplayString($setup.matchResultResolver(match.my_match_result, match.status).text), 5),
                                    _createElementVNode("p", null, [
                                      _hoisted_16,
                                      (match.challenger)
                                        ? (_openBlock(), _createElementBlock("strong", {
                                            key: 0,
                                            style: _normalizeStyle(`color: ${match.challenger.color}`)
                                          }, _toDisplayString(match.challenger.fullName), 5))
                                        : (_openBlock(), _createElementBlock("strong", _hoisted_17, "SWItaly"))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, [
                                  _hoisted_18,
                                  _createElementVNode("strong", null, _toDisplayString(match.my_points ? match.my_points : 0) + " Coins", 1)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["style"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}